<template>
	<div class="sf-table">
		<table class="qms-table">
			<tbody>
				<tr>
					<!-- OS&D 번호 -->
					<th class="col-1">{{ getMessage_('QWCC001031') }}</th>
					<td class="col-1"><el-input v-model="selectedRow.overSrgNo" readonly /></td>
					<!-- 작성자 -->
					<th class="col-1">{{ getMessage_('QWCC001382') }}</th>
					<td class="col-1"><el-input v-model="selectedRow.rgnNm" readonly /></td>
					<!-- 불량분류 -->
					<th class="col-1">{{ getMessage_('QWCC001700') }}</th>
					<td class="col-1">
						<sf-select-group
							labelPosition="left"
							:inputValue="selectedRow.badClCd"
							:options="badClCdList"
							:onChange="val => setSelectedRow(val, 'badClCd')"
							:placeholder="getMessage_('QWCC000008')"
							disabled
						/>
					</td>
					<!-- 현상 -->
					<th class="col-1" rowspan="2">{{ getMessage_('QWCC001036') }}</th>
					<td class="col-4" rowspan="2">
						<el-input
							type="textarea"
							v-model="editableData.badSbc"
							maxlength="250"
							:placeholder="getMessage_('QWCC001036')"
							:rows="4"
							show-word-limit
							:readonly="isDisabled"
						></el-input>
					</td>
				</tr>
				<tr>
					<!-- 품번 -->
					<th class="col-1">{{ getMessage_('QWCC000956') }}</th>
					<td class="col-1">
						<!-- <el-input v-model="selectedRow.partNo" readonly /> -->
						<search-input paramKey="partNo" :clearable="false" @commInput="setText" :propData="selectedRow.partNo">
							<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
						</search-input>
					</td>
					<!-- 발생일자 -->
					<th class="col-1">{{ getMessage_('QWCC001032') }}</th>
					<td class="col-1">
						<el-date-picker
							type="date"
							:value="selectedRow.occuDd.replaceAll('-', '')"
							format="yyyy-MM-dd"
							value-format="yyyyMMdd"
							readonly
						/>
					</td>
					<!-- 불량구분 -->
					<th class="col-1">{{ getMessage_('QWCC001033') }}</th>
					<td class="col-1">
						<sf-select-group
							labelPosition="left"
							:inputValue="selectedRow.badScnCd"
							:options="badScnCdList"
							:onChange="val => setSelectedRow(val, 'badScnCd')"
							:placeholder="getMessage_('QWCC000008')"
							disabled
						/>
					</td>
				</tr>
				<tr>
					<!-- 품명 -->
					<th class="col-1">{{ getMessage_('QWCC000957') }}</th>
					<td class="col-1"><el-input v-model="selectedRow.partNm" readonly /></td>
					<!-- 발생공정 -->
					<th class="col-1">{{ getMessage_('QWCC001030') }}</th>
					<td class="col-1">
						<sf-select-group
							labelPosition="left"
							:inputValue="selectedRow.powCd"
							:options="powCdList"
							:onChange="val => setSelectedRow(val, 'powCd')"
							:placeholder="getMessage_('QWCC000008')"
							disabled
						/>
					</td>
					<!-- 발생수량 -->
					<th class="col-1">{{ getMessage_('QWCC001000') }}</th>
					<td class="col-1">
						<el-input
							:value="editableData.occuQty"
							@input="onChangeValue"
							:placeholder="getMessage_('QWCC001000')"
							:maxlength="4"
							:readonly="isDisabled"
						/>
					</td>
					<!-- 불량원인 + 불량ID [2026-07-06] -->
					<th class="col-1">{{ getMessage_('QWCC002147') }}</th>
					<td class="col-1">
						<div style="display:flex; align-items:center; gap:4px;">
							<el-input style="flex:3" v-model="editableData.badCause" :readonly="isDisabled" maxlength="500" />
							<span style="white-space:nowrap; padding:0 4px;">{{ getMessage_('QWCC002148') }}</span>
							<el-input style="flex:2; min-width:80px;" v-model="editableData.badId" :readonly="isDisabled" maxlength="100" />
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<!-- 품번찾기 팝업 -->
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
	</div>
</template>

<script>
import * as Yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import partMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			editableData: {
				badSbc: '',
				badCause: '',
				badId: '',
				occuQty: ''
			}
		};
	},
	components: {
		SearchInput,
		partMngPopup
	},
	created() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		isDisabled() {
			//해당 권한이 없는 유저거나, ppr번호(보고서번호)가 있거나, osnd번호가 없을 경우 편집 불가
			return !this.isPqyUser || !!this.selectedRow.pprNo || !this.selectedRow.overSrgNo;
		},
		schema() {
			return Yup.object().shape({
				occuQty: Yup.number()
					.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001000')])) //{0}은(는) 숫자만 입력 가능합니다. , 검사시간
					.positive(this.$sf_formatString(this.getMessage_('MWPO000340'), [this.getMessage_('QWCC001000')])) //{0}은(는) 양수만 입력 가능합니다. , 검사시간
					.min(1, this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC001000'), '0'])) //{0}은 최소 {0} 초과하여 입력 해야합니다.
					.max(9999999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC001000'), '7'])) //{0}은 최대 {5} 자리까지 입력 가능합니다.
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001000')])) //{0}은(는) 팔수 입력 값 입니다. , 검사시간
			});
		}
	},
	watch: {
		isSaved(newVal) {
			if (newVal) {
				try {
					this.schema.validateSync(this.editableData);
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						message: this.getMessage_('MWCC000501'),
						buttons: [{ title: 'Ok', clickFn: this.save }]
					});
				} catch (error) {
					this.$sf_toast({ type: 'error', message: error.message });
				} finally {
					this.setState_({ key: 'isSaved', value: false });
				}
			}
		},
		editableData: {
			deep: true,
			handler() {
				this.setState_({ key: 'isSaved', value: false });
			}
		},
		selectedRow() {
			this.editableData.badSbc = this.selectedRow.badSbc;
			this.editableData.badCause = this.selectedRow.badCause;
			this.editableData.badId = this.selectedRow.badId;
			this.editableData.occuQty = this.selectedRow.occuQty;
			this.setState_({ key: 'isSaved', value: false });
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChangeValue(value) {
			value = value.replace(/[^-\.0-9]/g, '');
			this.editableData.occuQty = value;
		},
		setSelectedRow(value, key) {
			this.setSelectedRow_({ key, value });
		},
		async save() {
			try {
				this.$sf_toggleLoading(true);
				this.setSelectedRow_({ key: 'badSbc', value: this.editableData.badSbc });
				this.setSelectedRow_({ key: 'badCause', value: this.editableData.badCause });
				this.setSelectedRow_({ key: 'badId', value: this.editableData.badId });
				this.setSelectedRow_({ key: 'occuQty', value: this.editableData.occuQty });
				const { code, messageCd } = await this.updateUnit_();
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaved', value: false });
				this.$sf_toggleLoading(false);
			}
		},
		onPartPopup() {
			// console.log('this.editableData.partNo >>> ', this.selectedRow.partNo);
			this.$refs.partMngPopup.open(this.selectedRow.partNo);
		},
		sendData(param) {
			// console.log('param, selectedRow.partNo, param.partNo >>>', param, this.selectedRow.partNo, param.partNo);
			let oldPartNo = this.selectedRow.partNo;
			let newPartNo = param.partNo;
			this.$sf_toggleLoading(true);
			try {
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001119'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001131'), clickFn: () => this.updatePartNo(newPartNo) }], //저장
					closeFn: () => {
						this.setSelectedRow_({ key: 'partNo', value: oldPartNo });
					}
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
				this.$sf_toggleLoading(false);
			} finally {
				this.$sf_toggleLoading(false);
			}
			//this.setSelectedRow_({ key: 'partNo', value: param.partNo });
		},
		setText(param) {},
		async updatePartNo(newPartNo) {
			// console.log('param = newPartNo>>> ', newPartNo);
			this.$sf_toggleLoading(true);
			this.setSelectedRow_({ key: 'partNo', value: newPartNo });

			const { code, messageCd } = await this.updatePartNo_();
			if (code === 0 || code === 3) {
				this.$sf_toast({
					type: code === 0 ? 'ok' : 'error',
					message: this.getMessage_(messageCd)
				});
				code === 0 && this.$emit('Refresh');
			}
		}
	}
};
</script>
